// Developer     : Daiana Curcio
// Creation Date : 20-3-2025
// Version       : 1
// Description   : Editar los reclamos de desconexion

import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import { logEventos } from "../../../../services/services";

function EditarReclamoInst(props) {
  const [reclamo, setReclamo] = useState(props.datos);
  const [motivoReclamo, setMotivoReclamo] = useState(null);
  const [dirReclamo, setDirReclamo] = useState(null);
  const [disBtn, setDisBtn] = useState(false);

  const handleClose = () => {
    props.setOpen(false);
    props.actualizar();
  };

  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });

  const [motivosEmergencias, setMotivosEmergencias] = useState();
  const [prioridades, setPrioridades] = useState();
  const [dirsEntrega, setDirsEntrega] = useState();

  useEffect(() => {
    // getData(
    //   "/motivos_emergencias/activos/sinDesconexion",
    //   setMotivosEmergencias
    // );
    getData(
      "/motivos_emergencias/activos",
      setMotivosEmergencias
    );

    getData("/desplegables/reclamos", setPrioridades);
    getData("/direccionesentrega/cli/" + reclamo.id_cliente, setDirsEntrega);
  }, []);

  useEffect(() => {
    if (motivosEmergencias?.length) {
      const motivo = motivosEmergencias.find(
        (motivo) => motivo.id_motivo === reclamo.id_motivo
      );
      setMotivoReclamo(motivo || null);
    }
  }, [motivosEmergencias]);

  useEffect(() => {
    if (dirsEntrega?.length) {
      const direccion = dirsEntrega.find(
        (dir) => dir.id === reclamo.direccion_entrega
      );
      setDirReclamo(direccion || null);
    }
  }, [dirsEntrega]);

  async function modificarReclamo(e) {
    logEventos(
      `Guardar edición de reclamo ${reclamo.id_reclamo}`,
      "Reclamos Granel",
      "Se guardo la edición del reclamo",
      localStorage.getItem("user")
    );
    setDisBtn(true);
    putData(
      e,
      "/reclamos/update/" + reclamo.id_reclamo,
      {
        detalle: reclamo.detalle,
        usuario_modifica: localStorage.getItem("user"),
        estado: reclamo.estado
      },
      setNotificacion,
      props.actualizar()
    );

  }

  const almacenar = (e) => {
    setReclamo({ ...reclamo, [e.target.name]: e.target.value });
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
          },
        }}
      >
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.actualizar();
              props.setOpen(false);
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form onSubmit={modificarReclamo}>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Modificar reclamo N° {reclamo.id_reclamo}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <Grid
              container
              spacing={1}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={6}>
                {!!motivosEmergencias && (
                  <Autocomplete
                    // disabled={
                    //   reclamo.estado === 171 ||
                    //   reclamo.estado === 223 ||
                    //   reclamo.categoria === 281 ||
                    //   reclamo.categoria === 282
                    // }
                    fullWidth
                    disableClearable
                    onChange={(event, value) => {
                      setMotivoReclamo(value);
                    }}
                    noOptionsText={"Motivo no registrado"}
                    options={motivosEmergencias}
                    getOptionLabel={(option) =>
                      option?.descripcion_motivo || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      value ? option.id_motivo === value.id_motivo : false
                    }
                    value={motivoReclamo}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id_motivo}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.descripcion_motivo}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar motivo..."
                        {...params}
                        label="Motivo"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                {prioridades && (
                  <FormControl required fullWidth disabled>
                    <InputLabel> Prioridad</InputLabel>
                    <Select
                      label="Prioridad"
                      name="prioridad"
                      value={reclamo.prioridad}
                      onChange={almacenar}
                    >
                      {prioridades
                        ? prioridades.map((elemento) => (
                          <MenuItem key={elemento.id} value={elemento.id}>
                            {elemento.valor}
                          </MenuItem>
                        ))
                        : null}
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                {dirsEntrega && (
                  <Autocomplete
                    disabled
                    required
                    fullWidth
                    onChange={(event, value) => {
                      setDirReclamo(value);
                    }}
                    noOptionsText={"Dirección no registrada"}
                    options={dirsEntrega}
                    getOptionLabel={(option) => option?.direccion_entrega || ""}
                    isOptionEqualToValue={(option, value) =>
                      value ? option.id === value.id : false
                    }
                    value={dirReclamo}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        <b>{option.direccion_entrega} </b> -{" "}
                        {option.nombre_direccion}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        placeholder="Tipee para buscar dirección..."
                        {...params}
                        label="Dirección"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name="detalle"
                  value={reclamo.detalle}
                  onChange={almacenar}
                  margin="dense"
                  fullWidth
                  variant="outlined"
                  multiline
                  rows={4}
                  inputProps={{ maxLength: 500 }}
                />
              </Grid>
            </Grid>
            <br></br>
          </DialogContent>
          <DialogActions>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignContent="center"
            >
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                disabled={disBtn}
              >
                Confirmar
              </Button>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default EditarReclamoInst;
